import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Clock } from "lucide-react";

export default function CourseCard({ course, showProgress = false }) {
    return (
        <Link
            to={course.enrolled || showProgress ? `/learn/${course.id}` : `/catalog/${course.id}`}
            data-testid={`course-card-${course.id}`}
            className="group flex flex-col bg-ink-700 rounded-2xl border border-white/5 overflow-hidden hover:border-white/15 transition-all hover:-translate-y-1"
        >
            <div className="relative aspect-[4/3] overflow-hidden bg-ink-600">
                <img
                    src={course.thumbnail}
                    alt={course.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-ink-900/80 backdrop-blur-sm text-xs font-semibold text-white border border-white/10">
                    {course.category}
                </span>
            </div>

            <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-display font-bold text-white text-lg leading-tight line-clamp-2 group-hover:text-lime transition-colors">
                    {course.title}
                </h3>

                <div className="mt-4 flex items-center justify-between text-xs text-gray-400">
                    <span className="flex items-center gap-1.5">
                        <BookOpen className="w-3.5 h-3.5" />
                        {Math.round(course.durationHours * 1.5)} Lessons
                    </span>
                    <span className="flex items-center gap-1.5">
                        <Clock className="w-3.5 h-3.5" />
                        {Math.floor(course.durationHours)}h {Math.round((course.durationHours % 1) * 60)}m
                    </span>
                </div>

                {showProgress ? (
                    <div className="mt-5 pt-4 border-t border-white/5">
                        <div className="flex items-center justify-between text-xs mb-2">
                            <span className="text-gray-400">Progress</span>
                            <span className="text-lime font-semibold">{course.progress}%</span>
                        </div>
                        <div className="h-1.5 rounded-full bg-ink-600 overflow-hidden">
                            <div
                                className="h-full rounded-full bg-gradient-to-r from-grape to-lime"
                                style={{ width: `${course.progress}%` }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between gap-3">
                        <div className="flex items-center gap-2 min-w-0">
                            <img src={course.instructor.avatar} alt={course.instructor.name} className="w-7 h-7 rounded-full object-cover shrink-0" />
                            <div className="min-w-0">
                                <div className="text-xs font-semibold text-white truncate">{course.instructor.name.split(" ")[0]} {course.instructor.name.split(" ")[1]?.[0]}.</div>
                                <div className="text-[10px] text-gray-500 truncate">{course.instructor.title.split(" ")[0]}</div>
                            </div>
                        </div>
                        <span className="px-4 py-1.5 rounded-full bg-lime text-ink-900 text-xs font-bold shrink-0">
                            Enroll
                        </span>
                    </div>
                )}
            </div>
        </Link>
    );
}
